export default "__VITE_ASSET__B$Ta4LTh__"